import { RicosViewer } from './../ricos-viewer-next';

import { createWixRicosViewer } from './WixRicosViewerNext';

export const WixRicosViewer = createWixRicosViewer(RicosViewer);
